export enum ApiNaturalPartyTypeEnumCodeEnum {
    Driver = 'BEST',
    Contact = 'CONT',
    Witness = 'GETG',
    CoInsured = 'MEDE',
    ClaimReporter = 'MELD',
    Normal = 'NRML',
    Counterparty = 'TEGP',
}
